export class MockGtmHelper {
  addGtmEvent = jasmine.createSpy('addGtmEvent');
}
